module.exports = __webpack_public_path__ + "img/logo.bc50d7ca.png";